import { render, staticRenderFns } from "./tour-status-chip.vue?vue&type=template&id=e4bae6fc&"
import script from "./tour-status-chip.vue?vue&type=script&lang=js&"
export * from "./tour-status-chip.vue?vue&type=script&lang=js&"
import style0 from "./tour-status-chip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tour-status-chip.vue"
export default component.exports